interface TransferFeeDescription {
  CLOSING: string
  CHECK_REGULAR_DELIVERY: string
  CHECK_INTERNATIONAL_REGULAR_DELIVERY: string
  CHECK_OVERNIGHT_DELIVERY: string
  CHECK_INTERNATIONAL_OVERNIGHT_DELIVERY: string
  CHECK_OVERNIGHT_TO_BROKER: string
  DOMESTIC_WIRE: string
  INTERNATIONAL_WIRE: string
}
export type TransferFeeDescriptionType = keyof TransferFeeDescription
export const TransferFeeLabel = {
  CLOSING: 'IRA Closing Fee',
  CHECK_REGULAR_DELIVERY: 'Check Fee - Regular Delivery',
  CHECK_INTERNATIONAL_REGULAR_DELIVERY: 'Check Fee - International Regular Delivery',
  CHECK_OVERNIGHT_DELIVERY: 'Check Fee - Overnight Delivery',
  CHECK_INTERNATIONAL_OVERNIGHT_DELIVERY: 'Check Fee - International Overnight Delivery',
  CHECK_OVERNIGHT_TO_BROKER: 'Check Fee - Overnight To Broker Delivery',
  DOMESTIC_WIRE: 'Wire Withdrawal Fee - Domestic',
  INTERNATIONAL_WIRE: '	Wire Withdrawal Fee - International'
}

export type TransferFeesPayload = {
  customerDebitAmount: number
  apexCreditAmount: number
  correspondentNetAmount: number
  type: string
}

export type ConfiguredTransferFeesType = {
  [feeDescription: string]: {
    chargeCustomer: boolean
    customerDebit: number
    correspondentNet: number
    apexCredit: number
  }
}

export type TransferFeesType = {
  [feeDescription: string]: {
    chargeCustomer: boolean
    feeTotal: number
  }
}

export enum FeeTransferType {
  achDeposit = 'ACH_DEPOSIT',
  achWithdrawal = 'ACH_WITHDRAWAL',
  journalWithdrawal = 'JOURNAL_WITHDRAWAL',
  journalDeposit = 'JOURNAL_DEPOSIT',
  wireWithdrawal = 'WIRE_WITHDRAWAL',
  wireDeposit = 'WIRE_DEPOSIT',
  checkWithdrawal = 'CHECK_WITHDRAWAL',
  fee = 'FEE',
  credit = 'CREDIT',
  firstPartyJournal = 'FIRST_PARTY_JOURNAL',
  positionJournal = 'POSITION_JOURNAL',
  paypalDeposit = 'PAYPAL_DEPOSIT',
  paypalWithdrawal = 'PAYPAL_WITHDRAWAL',
  rtpDeposit = 'RTP_DEPOSIT',
  rtpWithdrawal = 'RTP_WITHDRAWAL'
}
